(function() {
  'use strict';

  const products = window.TAP_PRODUCTS || [];
  const brandsMap = window.TAP_BRANDS  || {};

  let activeBrand  = null;
  let activeModel  = null;
  let activeFilter = 'all';
  let galleryIdx   = 0;

  function fmt(n) {
    if (!n || n == 0) return '— F';
    return Number(n).toLocaleString('fr-FR') + ' F';
  }

  function getTag(product, prefix) {
    const tag = (product.tags || []).find(t => t.toLowerCase().startsWith(prefix.toLowerCase() + ':'));
    return tag ? tag.slice(prefix.length + 1) : '';
  }

  // ── NAV (sans "Toutes") ──────────────────────────────────
  function buildNav() {
    const c = document.getElementById('tapNavBrands');
    if (!c) return;
    c.innerHTML = Object.keys(brandsMap).map(b =>
      `<button class="brand-btn ${b === activeBrand ? 'active' : ''}"
        onclick="TAP.selectBrand('${b}')">${b}</button>`
    ).join('');
  }

  function selectBrand(b) {
    activeBrand = b;
    activeModel = null;
    activeFilter = 'all';
    buildNav();
    buildModelBar();
    updateHero();
    showCatalogueSection();
    render();
  }

  // ── MODEL BAR ────────────────────────────────────────────
  function buildModelBar() {
    const bar = document.getElementById('tapModelBar');
    if (!bar) return;
    if (!activeBrand) {
      bar.style.display = 'none';
      return;
    }
    bar.style.display = 'flex';
    const models = brandsMap[activeBrand] || [];
    bar.innerHTML = `
      <span class="model-label">${activeBrand}</span>
      <button class="model-btn ${activeModel === null ? 'active' : ''}" onclick="TAP.selectModel(null)">Tous les modèles</button>
      ${models.map(m =>
        `<button class="model-btn ${activeModel === m ? 'active' : ''}" onclick="TAP.selectModel('${m}')">${m}</button>`
      ).join('')}
    `;
  }

  function selectModel(m) {
    activeModel = m;
    buildModelBar();
    updateHero();
    render();
  }

  // ── HERO ─────────────────────────────────────────────────
  function updateHero() {
    const el = document.getElementById('tapHeroSub');
    if (!el) return;
    if (!activeBrand) {
      el.textContent = 'Choisis ta marque pour voir les accessoires disponibles';
      return;
    }
    let items = products.filter(p => getTag(p, 'brand') === activeBrand);
    if (activeModel) items = items.filter(p => getTag(p, 'model') === activeModel);
    const label = activeModel ? `${activeBrand} — ${activeModel}` : activeBrand;
    el.textContent = `${items.length} article${items.length > 1 ? 's' : ''} — ${label}`;
  }

  // ── BRAND SELECTOR (page d'accueil) ──────────────────────
  function buildBrandSelector() {
    const el = document.getElementById('tapBrandSelector');
    if (!el) return;
    const allBrands = Object.keys(brandsMap);
    el.innerHTML = allBrands.map(b => {
      const count = products.filter(p => getTag(p, 'brand') === b).length;
      return `
        <div class="brand-card" onclick="TAP.selectBrand('${b}')">
          <div class="brand-card-name">${b}</div>
          <div class="brand-card-count">${count} article${count > 1 ? 's' : ''}</div>
          <div class="brand-card-arrow">→</div>
        </div>`;
    }).join('');
  }

  function showCatalogueSection() {
    const selector = document.getElementById('tapSelectorSection');
    const catalogue = document.getElementById('tapCatalogueSection');
    const toolbar = document.getElementById('tapToolbar');
    if (selector)  selector.style.display  = 'none';
    if (catalogue) catalogue.style.display = 'block';
    if (toolbar)   toolbar.style.display   = 'flex';
  }

  function showSelectorSection() {
    activeBrand  = null;
    activeModel  = null;
    activeFilter = 'all';
    const selector = document.getElementById('tapSelectorSection');
    const catalogue = document.getElementById('tapCatalogueSection');
    const toolbar = document.getElementById('tapToolbar');
    const modelBar = document.getElementById('tapModelBar');
    if (selector)  selector.style.display  = 'block';
    if (catalogue) catalogue.style.display = 'none';
    if (toolbar)   toolbar.style.display   = 'none';
    if (modelBar)  modelBar.style.display  = 'none';
    buildNav();
    updateHero();
  }

  // ── FILTER ───────────────────────────────────────────────
  function setFilter(f, el) {
    activeFilter = f;
    document.querySelectorAll('.filter-pill').forEach(b => b.classList.remove('active'));
    if (el) el.classList.add('active');
    render();
  }

  // ── RENDER ───────────────────────────────────────────────
  function render() {
    const q = (document.getElementById('tapSearch')?.value || '').toLowerCase().trim();
    let items = [...products];

    if (activeBrand) items = items.filter(p => getTag(p, 'brand') === activeBrand);
    if (activeModel) items = items.filter(p => getTag(p, 'model') === activeModel);
    if (activeFilter !== 'all') items = items.filter(p => getTag(p, 'status') === activeFilter);
    if (q) items = items.filter(p =>
      (p.title || '').toLowerCase().includes(q) ||
      (p.tags  || []).some(t => t.toLowerCase().includes(q))
    );

    const rc = document.getElementById('tapResultsCount');
    if (rc) rc.textContent = items.length ? `${items.length} article${items.length > 1 ? 's' : ''}` : '';

    const grid = document.getElementById('tapGrid');
    if (!grid) return;

    if (!activeBrand) { grid.innerHTML = ''; return; }

    if (!items.length) {
      grid.innerHTML = `
        <div class="empty-state">
          <p>Aucun article trouvé</p>
          <small>Essaie un autre modèle ou retire les filtres</small>
        </div>`;
      return;
    }

    grid.innerHTML = items.map(p => {
      const brand  = getTag(p, 'brand');
      const model  = getTag(p, 'model');
      const status = getTag(p, 'status') || 'DISPO';
      const date   = getTag(p, 'date');
      const imgs   = p.images || [];
      const price  = p.price;
      const sku    = p.sku || '';

      const badgeTxt = status === 'DISPO' ? 'DISPO' : status === 'COMMANDE' ? 'CMD' : `ARRIVAGE${date ? '<br>' + date : ''}`;
      const badgeCls = status === 'DISPO' ? 'badge-dispo' : status === 'COMMANDE' ? 'badge-commande' : 'badge-arrivage';
      const imgHtml  = imgs[0] ? `<img src="${imgs[0]}" alt="${p.title}" loading="lazy">` : `<div class="card-no-img">🔧</div>`;
      const multiBadge = imgs.length > 1 ? `<span class="multi-img-badge">+${imgs.length - 1} 📷</span>` : '';

      return `
        <div class="prod-card" onclick="TAP.openDetail('${p.handle}')">
          <div class="card-img-wrap">
            <span class="pill-brand">${brand}</span>
            <span class="pill-model">${model}</span>
            ${imgHtml}${multiBadge}
          </div>
          <div class="card-body">
            <div class="card-ref">${sku}</div>
            <div class="card-name">${p.title}</div>
            <div class="card-footer">
              <span class="card-price">${fmt(price)}</span>
              <span class="badge ${badgeCls}">${badgeTxt}</span>
            </div>
          </div>
        </div>`;
    }).join('');
  }

  // ── DETAIL MODAL ─────────────────────────────────────────
  function openDetail(handle) {
    const p = products.find(x => x.handle === handle);
    if (!p) return;

    const brand  = getTag(p, 'brand');
    const model  = getTag(p, 'model');
    const status = getTag(p, 'status') || 'DISPO';
    const date   = getTag(p, 'date');
    const imgs   = p.images || [];
    galleryIdx   = 0;

    document.getElementById('tapModalRef').textContent  = p.sku || '';
    document.getElementById('tapModalName').textContent = p.title;

    const g = document.getElementById('tapModalGallery');
    if (!imgs.length) {
      g.innerHTML = '<div class="gallery-ph">🔧</div>';
    } else {
      g.innerHTML = `
        ${imgs.map((src, i) => `<img src="${src}" class="${i === 0 ? 'active' : ''}" alt="${p.title}" loading="lazy">`).join('')}
        ${imgs.length > 1 ? `
          <div class="gallery-nav-wrap">
            <button class="gal-btn" onclick="TAP.galPrev(event)">&#8249;</button>
            <button class="gal-btn" onclick="TAP.galNext(event)">&#8250;</button>
          </div>
          <div class="gallery-dots">
            ${imgs.map((_, i) => `<div class="gal-dot ${i === 0 ? 'active' : ''}" onclick="TAP.galGo(event,${i})"></div>`).join('')}
          </div>` : ''}
      `;
    }

    const statusLbl = status === 'DISPO' ? '✅ Disponible' : status === 'COMMANDE' ? '📦 Sur commande' : `🚢 Arrivage${date ? ' — ' + date : ''}`;
    const statusCls = status === 'DISPO' ? 's-dispo' : status === 'COMMANDE' ? 's-commande' : 's-arrivage';

    document.getElementById('tapModalDetails').innerHTML = `
      <div class="detail-card"><div class="detail-lbl">Prix</div><div class="detail-val price">${fmt(p.price)}</div></div>
      <div class="detail-card"><div class="detail-lbl">Statut</div><div class="detail-val ${statusCls}">${statusLbl}</div></div>
      <div class="detail-card"><div class="detail-lbl">Marque</div><div class="detail-val">${brand}</div></div>
      <div class="detail-card"><div class="detail-lbl">Modèle</div><div class="detail-val">${model}</div></div>
    `;

    const descEl  = document.getElementById('tapModalDesc');
    const descTxt = p.body_html ? p.body_html.replace(/<[^>]+>/g, '').trim() : '';
    if (descTxt) {
      document.getElementById('tapModalDescText').textContent = descTxt;
      descEl.style.display = '';
    } else {
      descEl.style.display = 'none';
    }

    document.getElementById('tapDetailOverlay').classList.add('open');
  }

  function closeDetail() { document.getElementById('tapDetailOverlay').classList.remove('open'); }

  function galGo(e, idx) {
    e.stopPropagation();
    const imgs = document.querySelectorAll('#tapModalGallery img');
    const dots = document.querySelectorAll('#tapModalGallery .gal-dot');
    imgs.forEach(i => i.classList.remove('active'));
    dots.forEach(d => d.classList.remove('active'));
    galleryIdx = idx;
    if (imgs[idx]) imgs[idx].classList.add('active');
    if (dots[idx]) dots[idx].classList.add('active');
  }
  function galNext(e) { e.stopPropagation(); const imgs = document.querySelectorAll('#tapModalGallery img'); galGo(e, (galleryIdx + 1) % imgs.length); }
  function galPrev(e) { e.stopPropagation(); const imgs = document.querySelectorAll('#tapModalGallery img'); galGo(e, (galleryIdx - 1 + imgs.length) % imgs.length); }

  // ── PUBLIC API ────────────────────────────────────────────
  window.TAP = { selectBrand, selectModel, setFilter, openDetail, closeDetail, galGo, galNext, galPrev, showSelectorSection };

  // ── INIT ─────────────────────────────────────────────────
  function init() {
    buildBrandSelector();
    buildNav();
    updateHero();

    document.getElementById('tapDetailOverlay')?.addEventListener('click', function(e) {
      if (e.target === this) closeDetail();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
